module.exports = __webpack_public_path__ + "img/12.962a4070.jpg";